import { RootState } from "../../store/root.reducer";
import { getUrlFilters } from "../../store/root.selectors";

const getBlockListLimit =
  (profileId) =>
  ({ urlFilters }: RootState): number =>
    urlFilters[profileId] && urlFilters[profileId].blacklist.limit;

export const getUrlFiltersLimitById =
  (profileId) =>
  (state: RootState): number =>
    getBlockListLimit(profileId)(state);

export const getUploadUrlState = ({ urlFilters }: RootState) =>
  urlFilters.uploadUrlsState;

export const geProfileUrlFilters = (profileId) => (state: RootState) =>
  getUrlFilters(state)[profileId];
